import React, { FC } from 'react';
import { ToolboxContent, ToolboxItemWrapper, ToolboxWrapper } from './ToolboxStyled';
import { ContentItem } from './type';

export const Toolbox: FC<{
  heigth?: 'header' | 'subheader';
  topContent?: ContentItem[];
  bottomContent?: ContentItem[];
}> = ({ topContent, bottomContent }) => {
  const hasHeader = document.getElementById('app-bar');

  return (
    <ToolboxWrapper hasHeader={!!hasHeader}>
      <ToolboxContent>
        <ToolboxItemWrapper>
          {topContent &&
            topContent.map((item: ContentItem, index) => {
              return item.button;
            })}
        </ToolboxItemWrapper>
        <ToolboxItemWrapper>
          {bottomContent &&
            bottomContent.map((item: ContentItem, index) => {
              return item.button;
            })}
        </ToolboxItemWrapper>
      </ToolboxContent>
    </ToolboxWrapper>
  );
};
